import React, { useEffect, useRef } from 'react';
import { Button, ArrowRight } from './ui'; 

interface Candlestick {
  x: number;
  y: number;
  width: number;
  height: number;
  color: string;
}

const HeroSection = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const candles: Candlestick[] = [];

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    const addCandlestick = () => {
      const height = Math.random() * 50 + 10;
      candles.push({
        x: canvas.width,
        y: canvas.height - height - Math.random() * 100,
        width: 2,
        height,
        color: Math.random() > 0.5 ? 'black' : 'red',
      });
    };

    const drawCandlesticks = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      candles.forEach((candle, index) => {
        ctx.fillStyle = candle.color;
        ctx.fillRect(candle.x, candle.y, candle.width, candle.height);
        candle.x -= 2;
        if (candle.x < -candle.width) {
          candles.splice(index, 1);
        }
      });
      if (Math.random() < 0.05) {
        addCandlestick();
      }
      requestAnimationFrame(drawCandlesticks);
    };
    drawCandlesticks();

    return () => {
      // Cleanup if needed
    };
  }, []);

  return (
    <section className="relative w-full py-12 md:py-24 lg:py-32 xl:py-48 bg-gradient-to-b from-background to-muted flex items-center justify-center">
      <canvas className="absolute top-0 left-0 w-full h-full z-0" ref={canvasRef}></canvas>
      <div className="container px-4 md:px-6 relative z-10">
        <div className="flex flex-col items-center space-y-4 text-center">
          <div className="space-y-2">
            <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl lg:text-6xl">
              Advanced Algorithmic Trading Solutions
            </h1>
            <p className="mx-auto max-w-[700px] text-muted-foreground md:text-xl">
              Harness the power of automated trading algorithms and machine learning to optimize your trading strategy and maximize returns.
            </p>
          </div>
          <div className="flex space-x-4">
            <Button variant="default">
              Schedule Demo <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button variant="default">View Performance</Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;